module.exports = __webpack_public_path__ + "img/citic.b1177e85.jpg";